<template>
  <div class="goods">
    <v-head :title="title"></v-head>
    <div class="meetingFont">
      <img :src="this.photoId" v-if="this.photoId" />
      <!-- <img src="@/assets/images/yuansu.jpg" v-if="!this.photoId" /> -->
      <div>
        <h3>会议名称：{{ meetingDetail.name }}</h3>
        <p style="display: flex;justify-content: space-between;">
          <span>举办时间：{{ meetingDetail.startDate | limitDate }}</span>
          <span>
            报名时间：{{ meetingDetail.registerStartDate | limitDate }}
          </span>
        </p>
      </div>
    </div>
    <div class="attendance">
      <h2 style="color: #000">
        <b>人员信息</b>
        <van-tag type="primary" size="medium" @click="addPerson">+ 添加参会人员</van-tag>
      </h2>
        <table>
            <thead>
                <td width=33.3%>姓名</td>
                <td width=33.3%>性别</td>
                <td width=33.3%>手机号码</td>
            </thead>
            <tr v-for="(item, index) in groupTableData" :key="index" v-show="isOpen || index < 6">
                <td>{{ item.name }}</td>
                <td>
                    <span v-if="item.gender == 1">男</span>
                    <span v-if="item.gender == 2">女</span>
                </td>
                <td>{{ item.mobile }}</td>
            </tr>
        </table>
        <div v-if="groupTableData.length==0" style="text-align:center; margin-top:15px">
            暂无人员
        </div>
      <div style="margin-top: 15px; text-align: center" v-if="groupTableData.length > 6" >
        <van-button
          v-show="!isOpen && groupTableData.length > 6"
          size="small"
          @click="isOpen = !isOpen"
          icon="plus"
          >展开全部信息</van-button
        >
        <van-button
          v-show="isOpen && groupTableData.length > 6"
          size="small"
          @click="isOpen = !isOpen"
          icon="plus"
          >收起</van-button
        >
      </div>
    </div>
    <div class="attendance">
        <h2 style="color: #000">
            <b>报名详情</b>
        </h2>
        <dl style="display: flex;justify-content: space-between; padding:0 15px">
            <dt>单价：￥{{ originalPrice }} / 人</dt>
            <dd>优惠价：<span style="color: red">￥{{ discountPrice }}</span> / 人</dd>
        </dl>
    </div>
    <div style="height: 56px"></div>
    <div class="pixedFond">
        <span>共 {{ groupTableData ? groupTableData.length : 0 }} 人</span>
        <p>合计：<span style="color: red">￥{{ priceTotal }}</span></p>
        <van-button type="primary" @click="onSubmit" v-show="meetStatus">下一步</van-button>
        <van-button type="primary" @click="onSubmitPay" v-show="!meetStatus" :disabled="disabled ">{{registerStep?'报名成功':'去支付'}}</van-button>
    </div>
  </div>
</template>
<script type="text/javascript">
import vHead from "@/components/Subhead.vue";

import { mapState, mapMutations, mapGetters } from "vuex";
import {
  Uploader,
  Toast,
  Field,
  Button,
  DatetimePicker,
  Popup,
  Cell,
  CellGroup,
  Checkbox,
  Divider,
  ContactList,
  SubmitBar,
  Tag
} from "vant";
import {
  getMeetingDetail,
  getDivisionData,
  getUser,
  getGroupRegisterMember,
  getHotelsDues,
  groupRegister,
  getPZUrl,
  getRegisterInfo
} from "@/api/dictionary";
export default {
  data() {
    return {
      title: "会议报名",
      meetingDetail: {},
      isOpen: false,
      priceTotal: null,
      discountPrice: "",
      originalPrice: "",
      groupTableData: [],
      userInfo: {},
      photoId: "",
      meetStatus:true,
      registerStep:false,
      disabled:false
    };
  },
  components: {
    vHead,
    [Uploader.name]: Uploader,
    [Toast.name]: Toast,
    [Field.name]: Field,
    [Button.name]: Button,
    [DatetimePicker.name]: DatetimePicker,
    [Popup.name]: Popup,
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [Checkbox.name]: Checkbox,
    [Divider.name]: Divider,
    [ContactList.name]: ContactList,
    [SubmitBar.name]: SubmitBar,
    [Tag.name]:Tag 
  },
  methods: {
    ...mapMutations(["setAddrList"]),
    getMeeting() {
      if (this.id) {
        getMeetingDetail({ meetingId: this.id }).then((res) => {
          this.meetingDetail = res.result.meetingDTO;
          getPZUrl({ id: this.meetingDetail.photoId }).then((res) => {
            this.photoId = res.result;
          });
          this.getHotelsDuesFc();
        });
      }
    },
    addPerson() {
      this.$router.push({ name: "addPerson", query: { meetingId: this.id } });
    },
    onSubmitPay(){
        this.$router.push({ name: "meetPaymentList"});
    },
    onSubmit(){

        if(new Date(this.meetingDetail.registerEndDate) < new Date()){
            Toast.fail("不在报名时间")
            return
        }
        if(!this.groupTableData.length){
             Toast.fail("至少添加一个参会人员")
             return;
        }
        let ruleForm ={
            meetingId:this.id,
            memberId:this.userInfo.id,
            priceTotal:this.priceTotal,
            price:this.originalPrice,
            registerNum:this.groupTableData.length
        }
        groupRegister(ruleForm).then(res =>{
          if(res.success){
            this.$router.push({ name: "meetPaymentList"});
          }else{
              Toast.fail('报名失败');
          }
        })
    },
    getUserInfo() {
      getUser().then((res) => {
        if (res.success) {
            this.userInfo = res.result;
            getGroupRegisterMember({meetingId: this.id,memberId: this.userInfo.id,}).then((res) => {
                this.groupTableData = res.result;
            });
            getRegisterInfo({meetingId:this.id,memberId:this.userInfo.id})
            .then(res =>{
                if(res.result && res.result.registerStep){
                    this.meetStatus= false;
                    if(res.result.registerStep==2||res.result.registerStep==1){
                        this.registerStep =true;
                        this.disabled = true
                    }
                }else{
                this.meetStatus= true;
                }
            })
        }
      });
    },
    getHotelsDuesFc() {
      let params = {
        meetingId: this.id,
        placeId: this.placeId,
        memberCategory: this.userInfo.memberCategory,
        memberType: this.userInfo.memberType,
      };
      getHotelsDues(params).then((res) => {
        if (res.success) {
          this.originalPrice = res.result.originalPrice;
          this.discountPrice = res.result.discountPrice;
          this.priceTotal =
            this.discountPrice * this.groupTableData.length;
        } else {
          Toast.fail("无法获取到报名费用");
        }
      });
    },
  },
  computed: {
    ...mapGetters(["searchAdd", "getCityList"]),
    id() {
      return this.$route.query && this.$route.query.meetingId;
    },
  },
  mounted() {
    this.getUserInfo();
    this.getMeeting();
    getDivisionData().then((res) => {
      this.setAddrList(res.result);
    });
  },
};
</script>

<style lang="less" scoped>
.meetingFont {
  font-size: 16px;
  line-height: 32px;
  border-bottom: #eee solid 10px;
  padding-bottom: 10px;
}
.meetingFont img {
  width: 100%;
}
.meetingFont > div {
  background: #fff;
  padding: 10px 15px;
  color:#000
}
.attendance {
  border-bottom: #eee solid 10px;
  padding-bottom: 20px;
  font-size: 16px; 
}
.attendance > button {
  border-left: none;
  border-right: none;
  border-top: 5px solid #eef2f5;
  border-bottom: 5px solid #eef2f5;
  border-radius: initial;
  padding: 25px 0;
  
}
.attendance h2 b{ font-size: 16px; color:#000; border-left: #1989fa solid 4px; padding-left: 15px; height: 20px; line-height: 20px;}
.attendance h2 {
  font-size: 16px;
  margin: 20px 15px;
  display: flex;
  justify-content: space-between;
}
.attendance table {
  width: 100%;
}
.attendance table td {
  padding: 12px 0;
  text-align: center;
  font-size: 15px;
}
.attendance thead {
  color: #333;
}
.attendance table tr:nth-child(odd),
.attendance thead {
  background: #eee;
}
.pixedFond{ display: flex; justify-content: space-between; align-items: center; font-size: 16px; padding:10px 3%;
background: #fff; box-shadow: #ddd 0 0 5px 0; position: fixed; bottom: 0; width: 94%;}
.pixedFond p{ font-size:18px}
.pixedFond p span{ font-size: 18px; font-weight: bold;}
</style>